import React from 'react';
import { CBPResponse, EsOutput, ShortButton } from "kx-common-components";
import AceResponse from "../../AceResponse/AceResponse";
import { Dimmer } from "semantic-ui-react";
import {QryFuncModal} from 'kx-common-components';
import _ from 'lodash'
import DifStatus from './difStatus';
import { statesToCWOrDISAlerts } from './ISFHeader';
import CarmStatus from './carmStatus/CarmStatus';

class HeaderAlert extends React.Component {
  constructor() {
    super();
    this.state = {
      comment: '',
      email: '',
      emailTitle: '',
      entrySummaryQueryResponse: {},
      entrySummaryDisplayOpen: false,
      loadEntrySummaryQueryState: 'N/A',
      showQueryDetails: "STATUS",
    }
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.mail = this.mail.bind(this);
    this.recordsRef = []
    this.titleRef = React.createRef();
  }
  toggleEntrySummaryDisplayOpen=(onoff)=>{this.setState({entrySummaryDisplayOpen:!!onoff})}

  formatCBPResponse(title, items) {
    let array = [title, '',];
    items.forEach(elem => {
      elem.forEach(item => {
        if (item) {
          if (item.className === 'ace-titles') {
            array.push('')
          }
          array.push(item.innerText)
        }
      })
    })
    return array
  }

  copyToClipboard = (e) => {
    let format = this.formatCBPResponse(this.titleRef?.current?.innerText, this.recordsRef).join(" \n ");
    let el = document.createElement('textarea');
    el.value = format;
    el.style = { position: 'absolute', left: '-9999px' };
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    this.setState({ copied: true });
    setTimeout(() => {
      this.setState({ copied: false })
    }, 1000);
  };

  mail = (e) => {
    let title = this.titleRef?.current?.innerText;
    let format = this.formatCBPResponse(this.titleRef?.current?.innerText, this.recordsRef).join('%0D%0A');
    this.setState({
      email: format,
      title: title + '%0A',
      aceTitle: title,
    })
  };

  shortTypeBtn(typeofquery,buttonlabel) {
    let highlighted = this.state.showQueryDetails==typeofquery;
    return (<ShortButton className={"ace-toggle-btn tabtop"  +(highlighted?" selected ":" unselected ")} onClick={()=>{
      this.setState({showQueryDetails:typeofquery})
    }}>{buttonlabel}
    </ShortButton>)
  }
  render() {
    // let hasentryj = this.props.entryNumber && this.state.entrySummaryQueryResponse[this.props.entryNumber.toUpperCase()];
    // if(this.props.entryNumber && !this.state.entrySummaryQueryResponse[this.props.entryNumber.toUpperCase()]){
    //   this.getEntrySummaryQueryResponseReference(this.props.entryNumber.toUpperCase(),false)
    // }
    // let maxnumberofmessages = 4;
    let shipmentId = this.props.id;
    let commentsforshipment = this.props.commentObjectForHeader[shipmentId] || [];
    if(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken'){
      let stateOfStates = _.get(this.props,"bolIdData.states.states");
      let statesAsCommentsForShipment = statesToCWOrDISAlerts(stateOfStates, true) ||[];
      commentsforshipment = [...statesAsCommentsForShipment, ...commentsforshipment]
    }
    if (commentsforshipment.length > 1) {
      var DIS = commentsforshipment[1].fieldmessage === 'DOCUMENT REQUIRED' ? true : false;
    }
    let { bolIdData,
      engineBolRecords
     } = this.props;
     const cleanedEngineBolRecords = (engineBolRecords||[]).filter(aaaa=>aaaa.masterBolNumber);
    let { showQueryDetails,
      selectedBolIndex } =this.state;
    // let otherbuttonvar = {otherbuttonIsOpen:showQueryDetails,
    //   otherbuttonJSX: (otherbuttonsareuseed) => {
    //     return (<>
    //     { this.shortTypeBtn("ES",otherbuttonsareuseed)}
    //     {this.shortTypeBtn("CR",otherbuttonsareuseed)}
    //     </>)}
    // }
    //otherbuttonvar = null;
    const engineSelectedBolNumber = cleanedEngineBolRecords && cleanedEngineBolRecords[selectedBolIndex || 0] && cleanedEngineBolRecords[selectedBolIndex || 0].masterBolNumber;
  
    if(engineSelectedBolNumber && bolIdData){
      bolIdData.masterBolNumber = engineSelectedBolNumber+"";
    }
    return (
      <div
        key={`${engineSelectedBolNumber}header-container${shipmentId}jghjyt${this.props.commentObjectForHeader["LASTUPDATEDKQ"]}`} style={{padding: "0px !important"}}
        className={' headermsgyo ' +(commentsforshipment.length > 0 && commentsforshipment[0].field === "Error" ? 'ace header-container error' : 'ace header-container')}>
        {
          <CBPResponse
            emailTitle={this.state.emailTitle}
            email={this.state.email}
            mail={this.mail}
            recordsRef={this.recordsRef}
            copyToClipboard={this.copyToClipboard}
            response={_.get(this.props,"commentsforshipment[1]",{})}
            messages={commentsforshipment || []}
            messagelimit={4}
            DIS={DIS}
            toggle={this.props.toggle}
            aceOpen={this.props.aceOpen}
            shipmentCountry={window.shipmentCountry}
            toggleEntrySummaryDisplayOpen={(window.shipmentCountry=="US") && this.toggleEntrySummaryDisplayOpen}
            loadEntrySummaryQuery={()=>{this.getEntrySummaryQueryResponseReference(this.props.entryNumber,true)}}
            entrySummaryDisplayOpen={this.state.entrySummaryDisplayOpen}
            bolIdData={{...bolIdData,nonModalWindow:true}}
          // otherbuttons={bolIdData && (window.shipmentCountry === "US") && otherbuttonvar}
           />
          


        }

        {
          this.state.copied &&
          <div className="sv success-popup" style={{ flexDirection: 'column' }}>
            <Dimmer active={true} page>
              <p style={{ color: 'black' }}>Copied!</p>
            </Dimmer>
          </div>
        }
        <div>
          {this.state.copySuccess}
        </div>
        {/* {hasentryj && this.state.entrySummaryDisplayOpen &&
        <div className="qryFuncGrid" >
          <b>Entry Summary Query Response:</b>
        <div id="qryFuncRightPanel" style={{height:'auto'}}>
            <div className="brokerQryOutput">
              <EsOutput qryOutput={{
                responseParams: {
                  cbpESCases: [
                    { cbpEntrySummaryStatus: this.state.entrySummaryQueryResponse[this.props.entryNumber.toUpperCase()] }
                  ]
                }
              }} 
              loadEntrySummaryQuery={()=>{this.getEntrySummaryQueryResponseReference(this.props.entryNumber,true)}}
              loadEntrySummaryQueryState={this.state.loadEntrySummaryQueryState}
              hideDetails={true}></EsOutput>
            </div>
          </div>
        </div>
      } */}

        {this.props.aceOpen &&
        <>
        
        {!(this.props.formType === "CARM" && this.props.isParentShipment) && this.shortTypeBtn("STATUS",window.shipmentCountry  == "CA" ? "IID STATUS DETAILS":"STATUS DETAILS" )}
        {(window.shipmentCountry  == "CA") && <>{this.shortTypeBtn("DIFSTATUS","DIF Status")}
        {(this.props.formType === "CARM") && this.shortTypeBtn("CARMSTATUS","CARM STATUS DETAIL")}
        </>}
        {window.shipmentCountry=="US" && <>
        { this.shortTypeBtn("RESPONSE_SUMMARY","STATUS SUMMARY")}
          { this.shortTypeBtn("ES","ES QUERY")}
          {this.shortTypeBtn("CR","CR QUERY")}
          {this.shortTypeBtn("BOL","BOL QUERY")}
          </>
        }
        <div className={"statustabboxtry"}>
          {showQueryDetails=="STATUS" &&
            <AceResponse
              showComment={this.state.showComment}
              titleRef={this.titleRef}
              recordsRef={this.recordsRef}
              toggle={this.props.toggle}
              toggleState={this.props.toggleState}
              id={this.props.id}
              aceOpen={this.props.aceOpen}
              closseAce={this.props.closseAce}
              entrySummaryLoaded={this.props.entrySummaryLoaded}
            />
          }
          {showQueryDetails=="DIFSTATUS" && 
          <DifStatus />}
          {showQueryDetails=="CARMSTATUS" && 
          <CarmStatus shipmentId={shipmentId} />}
          {showQueryDetails=="RESPONSE_SUMMARY" && bolIdData &&
            <QryFuncModal
              brokerId={window.brokerId}
              launchFrom="ISF_HEADER"
              hideLeftPanel
              dataType="RESPONSE_SUMMARY"
              width="75%"
              shipId={bolIdData.shipmentId}
              value={bolIdData.bol}
              bolNum={bolIdData.bol}
              baseUrl={window._env_.REACT_APP_BROKER_API_URL}
              entryNumber={bolIdData.entryNumber}
              recentQryCall={false}
              mot={bolIdData.modeOfTransport}
              bolIdData={{...bolIdData,nonModalWindow:true}}
              nonModalWindow={true} />
            }
          {showQueryDetails=="ES" && bolIdData &&
            <QryFuncModal
              brokerId={window.brokerId}
              launchFrom="ISF_HEADER"
              hideLeftPanel
              dataType="ES"
              width="75%"
              shipId={bolIdData.shipmentId}
              value={bolIdData.bol}
              bolNum={bolIdData.bol}
              baseUrl={window._env_.REACT_APP_BROKER_API_URL}
              entryNumber={bolIdData.entryNumber}
              recentQryCall={false}
              adminAccountReadonly={window.typeOfUser === "BROKER_KN_ADMIN"}
              mot={bolIdData.modeOfTransport}
              bolIdData={{...bolIdData,nonModalWindow:true}}
              nonModalWindow={true} />
            }
            {/* {JSON.stringify(bolIdData)} */}
            {showQueryDetails=="CR" && bolIdData &&
            <QryFuncModal
              brokerId={window.brokerId}
              launchFrom="ISF_HEADER"
              hideLeftPanel
              dataType="CR"
              width="75%"
              shipId={bolIdData.shipmentId}
              value={(bolIdData.entryNumber+"").substring(3,55)}
              bolNum={bolIdData.bol}
              baseUrl={window._env_.REACT_APP_BROKER_API_URL}
              entryNumber={bolIdData.entryNumber}
              recentQryCall={false}
              adminAccountReadonly={window.typeOfUser === "BROKER_KN_ADMIN"}
              mot={bolIdData.modeOfTransport}
              bolIdData={{...bolIdData,nonModalWindow:true}}
                nonModalWindow={true} />
            }
            {showQueryDetails == "BOL" && bolIdData && <>
              {cleanedEngineBolRecords && cleanedEngineBolRecords.length>1 && <select
              style={{borderRadius:'3px',padding:'3px',marginLeft:'3px'}}

                value={selectedBolIndex}
                onChange={(eee) => {
                  this.setState({ selectedBolIndex: parseInt(eee.target.value) });
                }}>
                {cleanedEngineBolRecords.map((item, iii) => {
                  return (<option value={iii} key={iii + item.masterBolNumber} >{item.masterBolNumber}</option>)
                })}
              </select>}
              <QryFuncModal
                brokerId={window.brokerId}
            launchFrom="BOLHeader"
            hideLeftPanel={true}
            dataType="BOL"
            width="75%"
            shipId={bolIdData.shipmentId}
            value={engineSelectedBolNumber || (bolIdData.modeOfTransport=="TRUCK"?(bolIdData.masterBolNumber || bolIdData.bol): bolIdData.bol)}
            bolNum={engineSelectedBolNumber || (bolIdData.modeOfTransport=="TRUCK"?(bolIdData.masterBolNumber || bolIdData.bol): bolIdData.bol)}
            baseUrl={window._env_.REACT_APP_BROKER_API_URL}
            entryNumber={bolIdData.entryNumber}
            recentQryCall={false}
            adminAccountReadonly={window.typeOfUser === "BROKER_KN_ADMIN"}
            mot={bolIdData.modeOfTransport}
            bolIdData={{...bolIdData,nonModalWindow:true}}
            nonModalWindow={true} /></>
        }
          </div>
          </>}
      </div>
    );
  }
}

export default HeaderAlert;
